import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ImageChangedNotifierService } from 'src/app/shared/product/components/image/image-changed.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { ImageUploadHandlerService } from 'src/app/shared/services/image-upload-handler.service';
import { Validators } from 'src/app/shared/validators';
import { FetchAdvertisementBannerService } from '../services/fetch-advertisement-banners.service';
import { handleAdvertisementBannerImage } from '../services/handleAdvertisementBannerImage.service';
import { manageAdvertisementBannerService } from '../services/manage-advertisement-banners.service';

@Component({
  selector: 'app-manage-advertisement-banner',
  templateUrl: './manage-advertisement-banner.component.html',
  styleUrls: ['./manage-advertisement-banner.component.scss'],
})
export class ManageAdvertisementBannerComponent implements OnInit {
  manageAdvertisementBannerForm!: FormGroup;
  success = false;
  OnlyNumPattern = /^\d+$/;
  webSitePattern = /^(((http|https):\/\/)?|(www.))?[a-zA-Z0-9]+(?=(\.[a-z]{2,6})\w+)(\/?.*\/?)*/;
  editMode = false;
  constructor(
    private translate: TranslateService,
    public formValidator: FormValidatorService,
    private snackBar: MatSnackBar,
    private fetchAdvBanners: FetchAdvertisementBannerService,
    private router: Router,
    private fb: FormBuilder,
    private imageUpload: ImageUploadHandlerService,
    private imageUploadRqst: handleAdvertisementBannerImage,
    private manageAdvBanner: manageAdvertisementBannerService,
    private imageChanged:ImageChangedNotifierService
  ) {}
  async uploadImage(image: any) {
    this.imageUpload.setUploaderService(this.imageUploadRqst);
    await this.imageUpload.setImageFile(image);
    return await this.imageUpload.upload();
  }
  advertisementBanner = {
    id: {
      fieldName: 'id',
      defaultValue: null,
      validators: [],
    },
    image: {
      fieldName: 'image',
      fieldNameAr: 'صورة',
      fieldType: 'product_image',
      isStaticUI: true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
            field: 'Banner Image',
          }),
        },
      ],
    },
    navigationLink: {
      fieldName: 'navigationLink',
      defaultValue: null,
      validators: [
        {
          validatorFn: Validators.required,
          message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
            field: 'navigationLink',
          }),
        },
        {
          validatorFn: Validators.pattern(this.webSitePattern),
          message: this.translate.instant('FORMS.VALIDATION.WebSite_Link_ONLY', {
            field: 'navigationLink',
          }),
        },
      ],
    },
    order: {
      fieldName: 'order',
      defaultValue: null,
      fieldType: 'number',
      validators: [
        {
          validatorFn: Validators.required,
          message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
            field: 'order',
          }),
        },
        {
          validatorFn: Validators.min(1),
          message: this.translate.instant('FORMS.VALIDATION.MAX', {
            field: 'order',
          }),
        },
      ],
    },
    isHidden: {
      fieldName: 'isHidden',
      defaultValue: false,
    },
  };

  async ngOnInit() {
    try {
      const advBanners=await this.fetchAdvBanners.make();
        if(advBanners.length>0){
          this.editMode = true;
          this.initForm();
          for (const banner of advBanners) {
            this.addAdvBannerGroup(banner.id, banner.image,banner.isHidden,banner.href,banner.order);
          }
        } else {
          this.initForm();
        }
      this.imageChanged.getImageChanged().subscribe((res:{img:HTMLImageElement,obj:any})=>{
        const width =res.img.width;
        const height =res.img.height;
        console.log(res.img.height,res.img.width);
        let errMessage = '';
        if (width > 1080 && width < 2400 && height > 250 && height < 600) {
          if (width / height >= 1.5) {
            return;
          } else {
            errMessage = 'width to height ratio must be 1.5 or more';

          }
        } else {
          errMessage = `width must be between 1080 or 2400 and height between 250 and 600}`;
        }
        res.obj.clearImage();
        res.obj.fieldErrors.image = errMessage;
      })
    } catch (err) {
      console.log(err);
    }
  }
  get advertisementBanners() {
    return this.manageAdvertisementBannerForm.get(
      'advertisement_Banners'
    ) as FormArray;
  }
  initForm() {
    this.manageAdvertisementBannerForm = this.fb.group({
      advertisement_Banners: this.fb.array([]),
    });
    if (this.advertisementBanners.length == 0 && !this.editMode) {
      this.addAdvBannerGroup();
    }
  }

  addAdvBannerGroup(
    id: number = null,
    image: string = null,
    isHidden: boolean = false,
    navigationLink: string = null,
    order: number = null
  ) {
      let newFormObj = { ...this.advertisementBanner };
      if (id && image) {
        newFormObj.image.defaultValue = image;
        newFormObj.id.defaultValue = id;
        newFormObj.navigationLink.defaultValue = navigationLink;
        newFormObj.isHidden.defaultValue = isHidden;
        newFormObj.order.defaultValue = order;
      } else {
        newFormObj.image.defaultValue = null;
        newFormObj.navigationLink.defaultValue = null;
        newFormObj.id.defaultValue = null;
        newFormObj.order.defaultValue = 1;
        newFormObj.isHidden.defaultValue = false;
      }
      this.advertisementBanners.push(
        this.formValidator.createForm(Object.values(newFormObj))
      );
    if (!this.advertisementBanners.valid) {
      this.formValidator.forceShowErrors();
    }
  }
  removeItems(i: number) {
    this.advertisementBanners.removeAt(i);
  }
  async onSubmit() {
    try {
      let imagePath;
      let formValue = this.advertisementBanners.value;

      for (const advBanner of formValue) {
        const imgVal = advBanner.image;
        if (typeof imgVal == 'object') {
          imagePath = (await this.uploadImage(imgVal)).location || null;
        } else {
          imagePath = imgVal || null;
        }
        advBanner.image = imagePath;
        advBanner.href = advBanner.navigationLink;
      }

        this.manageAdvBanner.setParams({
          ...formValue,
        });
        const res = await this.manageAdvBanner.make();
        if (res.success === true) {
          this.success = true;
          const resMessage=this.editMode?'Edited' :'Added'
          this.snackBar.open(`Advertisement Banners ${resMessage} Successfully!`, '', {
            duration: 3000,
          });
        }

      if (this.success) this.router.navigate(['/admin/actions/advertisement-banner']);
    } catch (err) {
      if (err.validationErrors) {
        const e = err.validationErrors.error;
        for (const error of e) {
          this.formValidator.addError(error.field, 'invalid', error.message);
          this.manageAdvertisementBannerForm.controls[error.field].setErrors({
            invalid: error.message,
          });
          this.formValidator.ShowErrors();
        }
      }
    }
  }

  convertAdvertisementBannersControls(index: number, name: string) {
    return this.advertisementBanners.controls[index].get(name) as FormControl;
  }
}
